<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de dispensação - Remédio em casa">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/farmacia/relatorio-dispensacao-remedio-casa/List'

export default {
    components: {List},
}
</script>